<template>
  <div class="train-page bg">
    <div class="nav-box bg" :class="{ 'from-eyejiajia': isFromEyeJiaJia }">
      <div class="logo" v-if="!isFromEyeJiaJia">
        <img src="@/assets/images/login-logo.png" />
        <span class="title">爱明玥</span>
      </div>
      <div class="nav-container">
        <div
          class="nav-item"
          :class="{ 'is-click': curTrainType === 'myTrain' }"
          @click="handleChangeTab('myTrain')"
          v-if="!isExpire"
        >
          我的训练
        </div>
        <div
          class="nav-item"
          :class="{ 'is-click': curTrainType === 'all' }"
          @click="handleChangeTab('all')"
        >
          训练指导
        </div>
        <div
          class="nav-item"
          :class="{ 'is-click': curTrainType === 'myAccount' }"
          @click="handleChangeTab('myAccount')"
        >
          我的账户
        </div>
      </div>
      <div class="signout">
        <el-dropdown>
          <el-button round>
            {{ name }} <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <span class="wid100" @click="openUpdatePwdDialog">修改密码</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span class="wid100" @click="handleLogout">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="main-box">
      <div v-if="curTrainType === 'all'">
        <acc-class
          v-if="role === AccountType.ADJUSTMENT"
          class="main-container intro"
        ></acc-class>
        <div v-else>
          <trainer-guide @dialog-show="handleOpenDialog"></trainer-guide>
        </div>
      </div>
      <div v-else-if="curTrainType === 'myTrain'">
        <div class="train-box" v-loading="trainListLoading">
          <div class="train-container" v-if="trainList.length > 0">
            <div v-for="(obj, j) in trainList" :key="j" class="single">
              <div
                :class="{ content: true, disHover: lock }"
                @mouseover="lock ? disHover() : handleHover(j)"
                @mouseleave="lock ? disHover() : handleLeave()"
              >
                <div class="img"><img :src="iconUrl(obj)" /></div>
                <div class="name">
                  <span class="trainName">{{ obj.trainName }}</span>
                  <div
                    class="trainType"
                    :style="{
                      'background-color': getCurrentColorType(obj.trainType),
                    }"
                    v-html="typeName(obj.trainType)"
                  ></div>
                </div>

                <div
                  class="hoverDiv"
                  v-show="obj.isPreLoaded && hoverDiv && hoverIndex === j"
                >
                  <el-button type round @click="startTrain(obj)">{{
                    obj.trainType === 'EXAM' ? '开始检查' : '开始训练'
                  }}</el-button>
                </div>
                <!-- 加载进度条 -->
                <div class="preload" v-show="!obj.isPreLoaded">
                  <el-progress
                    type="circle"
                    :percentage="obj.percentage"
                    :width="150"
                  ></el-progress>
                </div>
                <!-- 过期处理 -->
                <div v-if="lock" class="expire-box">
                  <img src="../../assets/images/lock.png" />
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="!trainListLoading" class="no-data">
            <img src="../../../public/images/rsxs.png" alt />
            <div>暂无匹配的训练，请联系您的医生</div>
          </div>
        </div>
      </div>
      <div v-else-if="curTrainType === 'myAccount'">
        <my-account></my-account>
      </div>
    </div>
    <el-dialog
      class="intro-dialog"
      :title="introForm.title"
      :visible.sync="introDialog"
      v-if="introDialog"
      center
      width="40%"
    >
      <div v-if="introForm.content" class="center">
        <p v-for="(item, index) in introForm.content" :key="index">
          {{ item }}
        </p>
      </div>
      <div v-else-if="introForm.typeList" class="padding40">
        <div
          v-for="(item, index) in introForm.typeList"
          :key="index"
          class="type-item"
        >
          <h4 class="typeTitle">{{ item.typeName }}</h4>
          <div>
            <p
              class="textIdent"
              v-for="(content, index) in item.contents"
              :key="index"
            >
              {{ content }}
            </p>
          </div>
          <div class="typeImg-wrapper">
            <img
              class="typeImg"
              v-for="(src, index) in item.imgList"
              :key="index"
              :src="src"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="introDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="updatePwd"
      v-if="updatePwd"
      width="30%"
    >
      <el-form
        :model="pwdForm"
        :rules="loginFormjRules"
        ref="pwdForm"
        label-width="100px"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            type="password"
            v-model="pwdForm.oldPassword"
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            type="password"
            v-model="pwdForm.newPassword"
            placeholder="请输入新密码"
            @change="newpwdChange"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            type="password"
            v-model="pwdForm.confirmPassword"
            placeholder="请确认新密码"
            @change="confirmpwdChange"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleChange">确 定</el-button>
        <el-button @click="updatePwd = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 实际训练的容器dialog -->
    <el-dialog
      class="trainFrame"
      :visible.sync="trainVisible"
      v-if="trainVisible"
      fullscreen
      :show-close="false"
    >
      <div slot="title" class="iframe-btn-box" @click.self="catchClick">
        <!-- 秒表计时器 -->
        <span class="timing">{{ minandsec }}</span>
        <span class="close" @click.stop="stopConfirm">
          <i class="el-icon-circle-close-outline"></i>退出
        </span>
      </div>
      <div id="game-frame">
        <div
          id="loading-box"
          v-loading="loading"
          element-loading-text="拼命加载中"
          v-if="loading"
        ></div>
        <iframe
          id="game"
          ref="iframe"
          v-on:load="loadingDone"
          :src="trainPath"
          allowfullscreen
        ></iframe>
      </div>
    </el-dialog>
    <el-dialog :visible="showTrainerWechat" width="600px" :show-close="false">
      <TrainerWechatDialog
        :qrcode="twQrcode"
        :phone="phone"
        @confirm="handleConfirm"
      ></TrainerWechatDialog>
    </el-dialog>
  </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'
import {
  getAllTrainList,
  saveTrainRecord,
  getDailyTrainTime,
  postLoadTime,
} from '@api/train'
import { validateForm, getDuration } from '@utils'
import { getToken } from '@utils/auth'
import { homeIntroductions } from '@src/constant/home'
import loginFormjRules from '@utils/rules/loginFormRules'
import { type } from '@src/constant/train'
import { updatePwd } from '@api/login'
import screenfull from 'screenfull'
import { namespace } from 'vuex-class'
import { encryption } from '@utils/crypto'
import AccClass from './AccClass.vue'
import TrainerWechatDialog from '@/components/TrainerWechatDialog.vue'
import MyAccount from './MyAccount.vue'
import TrainerGuide from './TrainerGuide.vue'
import { AccountType } from '@/constant/user'
import {
  getUnPreloadedTrains,
  getTrains,
  creatIframe,
  preLoadIframe,
} from './preload'

const typeColorList = [
  { type: 'EX', name: '视觉精细', color: '#ff4d94' },
  { type: 'ST', name: '视觉刺激', color: '#3ECC88' },
  { type: 'MFBF', name: '脱抑制', color: '#00C7FF' },
  { type: 'FU', name: '集合训练', color: '#BF90FF' },
  { type: 'DV', name: '散开训练', color: '#BF90FF' },
  { type: 'SV', name: '同时视', color: '#FE8347' },
  { type: 'STE', name: '立体视', color: '#FCCE19' },
]
const moduleUser = namespace('user')
const moduleTrain = namespace('train')

@Component({
  components: {
    AccClass,
    TrainerWechatDialog,
    MyAccount,
    TrainerGuide,
  },
})
export default class Train extends Vue {
  num = 0
  len = ''
  preState = false
  nextState = true
  predisabled = true
  nextdisabled = false
  trainPath = ''
  trainListLoading = false
  trainList = []
  hoverIndex = ''
  hoverDiv = false
  typeList = type
  homeIntroductions = homeIntroductions
  line1 = homeIntroductions.slice(0, 2)
  line2 = homeIntroductions.slice(2)
  introForm = {}
  introDialog = false
  curTrainType = 'myTrain'
  updatePwd = false
  pwdForm = {
    confirmPassword: '',
    newPassword: '',
    oldPassword: '',
  }
  typeColorList = typeColorList
  // ifram
  trainVisible = false
  loading = true
  isFullscreen = false
  start_time = 0
  id = undefined
  // 秒表计时器
  minandsec = '00:00'
  timer = null
  AccountType = AccountType
  iframe = null
  preLoadStatus = {
    preLoading: true,
    total: 0,
    preLoaded: 0,
    failed: 0,
  }

  @moduleTrain.Getter curTrainTypeInfo
  @moduleTrain.Getter curTrain
  @moduleTrain.Mutation SET_CUR_TRAIN

  @moduleUser.Action Logout
  @moduleUser.Action FeLogout
  @moduleUser.Getter name
  @moduleUser.Getter openDay
  @moduleUser.Getter usedDay
  @moduleUser.Getter role
  @moduleUser.Getter dailyTrainDuration
  @moduleUser.Getter singleTrainDuration
  @moduleUser.Getter pid
  @moduleUser.Getter isExpire

  @moduleUser.Getter twQrcode
  @moduleUser.Getter phone
  @moduleUser.Getter avgLoadTime
  @moduleUser.State showTrainerWechat
  @moduleUser.Mutation SET_SHOW_TRAINER_WECHAT

  get lock() {
    return this.role === 1 ? this.usedDay > this.openDay : false
  }
  get isFromEyeJiaJia() {
    return this.role === AccountType.MYOPIA
  }

  created() {
    this.loginFormjRules = loginFormjRules
    if (this.isFromEyeJiaJia) {
      this.homeIntroductions = homeIntroductions.filter(item =>
        ['眼镜佩戴说明', '训练小贴士'].includes(item.title)
      )
    }
    if (this.isExpire) {
      this.curTrainType = 'myAccount'
    }
    if (
      this.$route.query.curTrainType === 'myAccount' ||
      this.$route.query.out_trade_no // 支付宝支付的订单号
    ) {
      this.$router.push({
        query: {
          curTrainType: undefined,
          out_trade_no: this.$route.query.out_trade_no,
        },
      })
      this.curTrainType = 'myAccount'
    }
  }

  getCurrentColorType(trainType) {
    const target = this.typeColorList.find(el => el.type === trainType)
    return target ? target.color : 'red'
  }

  async mounted() {
    if (!this.isExpire) {
      const trains = await this._getAllTrainList()
      // trains预处理
      this.trainList = getUnPreloadedTrains(trains, getTrains())
      this.iframe = creatIframe('preload')
      document.body.appendChild(this.iframe)
      preLoadIframe(this.trainList, this.preLoadStatus, this.iframe, {
        success: this.handleLoadSuccess,
        avgTime: this.avgLoadTime,
      })
    }
  }

  // 加载成功处理回调
  handleLoadSuccess({ trainIndex, trains, startTime }) {
    if (trainIndex === -1) return
    postLoadTime({
      trainId: trains[trainIndex].trainId,
      startTime: Math.floor(startTime / 1000),
      endTime: Math.floor(Date.now() / 1000),
    })
  }

  async _getAllTrainList() {
    try {
      this.trainListLoading = true
      const res = await getAllTrainList()
      return res
    } catch (error) {
      console.log(error)
    } finally {
      this.trainListLoading = false
    }
  }

  handleChangeTab(type) {
    this.curTrainType = type
  }

  handleOpenDialog(item) {
    this.introForm = { ...item }
    if (item.title === '微信指导') {
      this.SET_SHOW_TRAINER_WECHAT(true)
    } else {
      this.introDialog = true
    }
  }

  handleConfirm() {
    this.SET_SHOW_TRAINER_WECHAT(false)
  }

  disHover() {
    // console.log('您已到期')
  }
  handleHover(j) {
    this.hoverDiv = true
    this.hoverIndex = j
  }
  handleLeave() {
    this.hoverDiv = false
    this.hoverIndex = ''
  }

  async _afterIframeLoaded() {
    this.showTiming()
    try {
      const params = {
        id: this.id,
        trainId: this.curTrain.trainId,
        trainName: this.curTrain.trainName,
      }
      const res =
        this.curTrain.trainType !== 'EXAM' ? await saveTrainRecord(params) : ''
      this.id = res.data.id
    } catch (error) {
      console.log(error)
    }
  }
  handlePre() {
    if (this.num <= this.len - 1 && this.num !== 0) {
      this.num--
      this.predisabled = this.num === 0 ? true : false
      this.nextdisabled = this.num <= this.len - 1 ? false : true
    }
    console.log('pre', this.num)
  }
  handleNext() {
    this.num = this.num + 1
    this.nextdisabled = this.num >= this.len - 1 ? true : false
    this.predisabled = this.num <= this.len - 1 ? false : true
    console.log('next', this.num)
  }

  iconUrl(train) {
    if (train.trainType === 'EXAM' && train.trainIcon) {
      return train.trainIcon
    }
    return `images/traintype/${train.trainType}.png`
  }
  typeName(traintype) {
    const target = this.typeList.find(item => item.type === traintype)
    return target ? target.name : '默认'
  }
  async startTrain(train) {
    const res = await getDailyTrainTime()
    if (
      res.data >= this.dailyTrainDuration * 60 &&
      train.trainType !== 'EXAM'
    ) {
      this.$confirm(
        `根据您的病历情况，每天训练时间不宜超过${
          this.dailyTrainDuration
        }分钟，明天再来吧。`,
        '专家建议',
        {
          confirmButtonText: '确定',
          type: 'warning',
        }
      )
        .then(() => {})
        .catch(() => {})
    } else {
      this.id = undefined
      this.trainVisible = true
      this.loading = true
      this.minandsec = '00:00'
      this.handleFullscreen()
      this.SET_CUR_TRAIN(train)
      this.trainPath =
        process.env.VUE_APP_TRAIN_PREFIX + this.curTrain.trainPath
    }
  }

  // 开始计时
  showTiming() {
    let digital = 0
    clearInterval(this.timer)
    // todo question 读秒器的设置
    this.timer = setInterval(() => {
      digital++
      let m = parseInt(digital / 60)
      let s = parseInt(digital % 60)
      this.minandsec = this.toDub(m) + ':' + this.toDub(s)
      if (
        digital === this.singleTrainDuration * 60 &&
        this.curTrain.trainType !== 'EXAM'
      ) {
        this.$confirm(
          `根据您的病历情况，每次训练时间不宜超过${
            this.singleTrainDuration
          }分钟，休息一会吧。`,
          '专家建议',
          {
            confirmButtonText: '取消',
            cancelButtonText: '确定',
            type: 'warning',
          }
        )
          .then(() => this.$message('继续训练'))
          .catch(() => this.stopTrain(this.hide))
      }
    }, 1000)
  }
  // handleOpenDialog(item) {
  //   this.introForm = { ...item }
  //   this.introDialog = true
  // }
  // 时间补零
  toDub(time) {
    return time < 10 ? '0' + time : '' + time
  }
  // 全屏
  handleFullscreen() {
    if (!screenfull.enabled) {
      // T5 还判断了是否为客户端
      console.log('FullScreen:you browser can not work')
      return false
    }
    if (this.isFullscreen) {
      screenfull.exit()
      this.isFullscreen = false
    } else {
      screenfull.request()
      this.isFullscreen = true
    }
  }
  stopConfirm() {
    const duration = getDuration(this.start_time)
    if (duration < 5 && this.curTrain.trainType !== 'EXAM') {
      this.$confirm('每次训练至少5分钟，您确定结束当前训练吗？', '专家建议', {
        confirmButtonText: '取消',
        cancelButtonText: '确定',
        type: 'warning',
      })
        .then(() => this.$message('继续训练'))
        .catch(() => this.stopTrain(this.hide))
    } else {
      this.stopTrain(this.hide)
    }
  }
  async stopTrain(done) {
    clearInterval(this.timer)
    const params = {
      id: this.id,
      trainId: this.curTrain.trainId,
      trainName: this.curTrain.trainName,
    }
    const res =
      this.curTrain.trainType !== 'EXAM' ? await saveTrainRecord(params) : ''
    console.log(res)
    done()
  }
  hide() {
    this.trainVisible = false
    this.handleFullscreen()
  }
  async loadingDone() {
    this.loading = false
    document.getElementById('game').focus()
    const iframe = this.$refs.iframe
    this.start_time = parseInt(Date.now() / 1000)
    iframe.contentWindow.postMessage(
      {
        action: 'userInfo',
        pid: this.pid,
        token: getToken(),
      },
      '*'
    )
    await this._afterIframeLoaded()
    iframe.onerror = (message, url, row, col, error) => {
      console.log('iframe 报错')
      console.log(message, url, row, col, error)
      this.loading = false
      return true
    }
  }
  catchClick() {
    if (this.trainVisible) {
      document.getElementById('game').focus()
    }
  }
  async handleLogout() {
    await this.Logout()
    location.reload()
  }
  openUpdatePwdDialog() {
    this.updatePwd = true
    this.pwdForm = {
      confirmPassword: '',
      newPassword: '',
      oldPassword: '',
    }
  }
  newpwdChange() {
    if (this.pwdForm.newPassword === this.pwdForm.oldPassword) {
      this.$message.warning('新密码和旧密码不能相同')
      return false
    } else {
      return true
    }
  }
  confirmpwdChange() {
    if (
      this.pwdForm.newPassword !== '' &&
      this.pwdForm.confirmPassword !== this.pwdForm.newPassword
    ) {
      this.$message.warning('确认密码和新密码输入不一致')
      return false
    } else {
      return true
    }
  }
  async handleChange() {
    const valid = await validateForm.call(this, 'pwdForm')
    valid && this.newpwdChange() && this.confirmpwdChange() && this.changePwd()
  }

  async changePwd() {
    // const encryptForm = encryption({
    //   data: this.pwdForm,
    //   encryptArr: ['oldPassword', 'newPassword'],
    // })
    // const res = await updatePwd({
    //   oldPassword: encryptForm.oldPassword,
    //   newPassword: encryptForm.newPassword,
    // })
    const encryptOld = encryption({
      data: this.pwdForm,
      encryptArr: ['oldPassword'],
    })
    const encryptNew = encryption({
      data: this.pwdForm,
      encryptArr: ['newPassword'],
    })
    // console.log(encryptNew.newPassword, encryptOld.oldPassword)
    const res = await updatePwd({
      oldPassword: encryptOld.oldPassword,
      newPassword: encryptNew.newPassword,
    })
    if (res.code === 0) {
      this.updatePwd = false
      await this.FeLogout()
      location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .line1 {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 60px;
    .advice-wrapper {
      width: 388px;
      height: 352px;
      margin: 0 35px;
    }
  }
  .line2 {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.wid100 {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.train-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  // background-image: url('../../assets/images/index-bg.png');
  background-color: #fff;
  .nav-box {
    position: relative;
    height: 100px;
    min-height: 100px;
    margin-bottom: 25px;
    background-color: #f6f6f6;
    &.from-eyejiajia {
      background-image: url('../../assets/images/index2.png');
    }
    .logo {
      position: absolute;
      display: flex;
      align-items: center;
      bottom: 25px;
      left: 120px;
      img {
        width: 69px;
        height: 46px;
        margin-right: 20px;
      }
      span {
        color: #666666;
        letter-spacing: 10px;
        font-size: 40px;
      }
    }

    .signout {
      position: absolute;
      bottom: 20px;
      right: 120px;
      button {
        width: 100%;
        height: 60px;
        border-radius: 30px;
        background: #3dcc85;
        font-size: 22px;
        font-family: FZZhunYuan-M02S;
        font-weight: 400;
        color: #ffffff;
        border: none;
      }
    }
    .nav-container {
      display: flex;
      position: absolute;
      bottom: 0px;
      left: 392px;
      font-size: 30px;
      font-family: FZZhunYuan-M02S;
      font-weight: 400;
      .nav-item {
        color: #333333;
        margin: 0 30px 0;
        padding-bottom: 32px;
        &.is-click {
          color: #3dcc85;
          border-bottom: 4px solid #3dcc85;
        }
        &:hover {
          color: #3dcc85;
          cursor: pointer;
        }
      }
    }
  }
  .main-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    .main-container {
      // height: 100%;
      margin: 50px auto 0;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap: wrap;
      padding: 0 20px;
      max-width: 1920px;
      &.intro {
        padding: 0 50px;
      }
      /deep/ .main-intro-wrapper {
        max-width: 388px;
        flex: 1;
        margin: 0 20px;
        .main-intro__content {
          width: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
.train-box {
  background-color: #fff;
  margin-top: 100px;
  .train-container {
    .single {
      .content {
        border-radius: 20px;
        .img {
          height: 200px;
        }
        .name {
          border-radius: 0 0 20px 20px;
          background: #fafafa;
        }
        .preload {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 68px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0, 0, 0, 0.7);
          transition: all 0.5s;
          &:hover {
            background: rgba(0, 0, 0, 0.5);
          }
          /deep/ .el-progress__text {
            color: #fff;
          }
        }
      }
    }
  }
  .no-data {
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
  }
}
.center {
  padding: 0 80px;
}
.padding40 {
  padding: 0 40px;
  .type-item {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px dotted #ccc;
  }
  .typeTitle {
    margin: 0;
    font-size: 16px;
    line-height: 20px;
  }
  .textIdent {
    text-indent: 2em;
  }
  .typeImg-wrapper {
    display: flex;
    justify-content: space-around;
    .typeImg {
      width: 30%;
    }
  }
}
</style>

<style lang="scss"></style>
